import { createBrowserRouter } from 'react-router-dom';
import Oficinas from '../pages/oficinas';
import Index from '../pages';

export default createBrowserRouter([
  {
    path: '/',
    children: [
      {
        element: <Index />,
        path: '/',
      },
      {
        element: <Oficinas />,
        path: '/oficinas',
      },
    ],
  },
]);
